import {
  FieldValue,
  FieldLabel,
  StudentIdPill,
  DataFieldContainer,
} from './service/SsaProfileTabStyled';

export const DataField = ({ label, value, isPill }) => (
  <DataFieldContainer>
    <FieldLabel>{label}</FieldLabel>
    {isPill ? (
      <StudentIdPill>{value}</StudentIdPill>
    ) : (
      <FieldValue>{value || '—'}</FieldValue>
    )}
  </DataFieldContainer>
);
